<i18n src="./resources/locales.json"></i18n>

<template>
  <v-text-field
    ref="searchInput"
    v-model="searchString"
    type="search"
    class="search-input"
    prepend-inner-icon="mdi-magnify"
    clearable dense hide-details
    :placeholder="placeholder"
    :loading="isLoading"
    @input="$emit('input', searchString)"
    autocomplete="off"
  >
    <template v-slot:progress>
      <v-progress-circular
        indeterminate
        width="2"
        size="24"
        color="var(--v-primary-lighten1)"
        class="ml-2"
      />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'SmsSearchInput',

  props: {
    placeholder: {
      type: String,
      default: 'Search item'
    }
  },

  data() {
    return {
      searchString: '',
      isLoading: false
    };
  },

  methods: {
    _forceClear() {
      this.$refs.searchInput.clearableCallback();
    }
  }
};
</script>

<style scoped>
.search-input {
  position: relative;
  z-index: 2;
}
</style>

<style src="./global.scss" lang="scss" />
